(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function($) {
        Site.run();

        window.initTypehead = function() {


            var $typeheads = $('.typehead');

            if ($typeheads.length) {

                $typeheads.each(function () {
                    var $that = $(this);
                    var searchData = new Bloodhound({
                        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
                        queryTokenizer: Bloodhound.tokenizers.whitespace,
                        remote: {
                            url: $that.attr('data-url') + '?q=%QUERY',
                            wildcard: '%QUERY'
                        }
                    });

                    $(this).typeahead(null, {
                        //   name: 'search',
                        highlight: true,
                        display: 'value',
                        limit: 9,
                        source: searchData,
                        //limit:10,
                        //templates:{
                        //    suggestion: function(data){
                        //        return data.value;
                        //    }
                        //}
                    }).on('typeahead:asyncrequest', function () {
                        // $(this).addClass('loader');
                        $(this).parent().append('<div id="typeahdloader"><div class="loader loader-default"></div></div>');
                    })
                        .on('typeahead:asynccancel typeahead:asyncreceive', function () {
                            //   $(this).removeClass('loader');
                            $('#typeahdloader').remove();
                        });
                    ;
                });

            }
        }

        window.initTypehead();

    });





})(document, window, jQuery);
